/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Sub_TitleInputs */

const en_settings_sub_title = /** @type {(inputs: Settings_Sub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription`)
};

const id_settings_sub_title = /** @type {(inputs: Settings_Sub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langganan`)
};

/**
* | output |
* | --- |
* | "Subscription" |
*
* @param {Settings_Sub_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_sub_title = /** @type {((inputs?: Settings_Sub_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sub_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_sub_title(inputs)
	return en_settings_sub_title(inputs)
});